import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import elitemedicalcare from "../images/Elite Medical care building.jpeg";


function About() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="light" />
            <div className='diagnosticskrishnanagar'>
                <div className="album py-1 ">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>

                                <li className="breadcrumb-item active" aria-current="page">About Us <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg> </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            
            <div className='aboutus'>
                <br />
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <div class="card-body">
                                <h3 style={{color:"#034b4c"}} className="card-title"><b style={{color:"#CC000A"}}>About Us </b> ELITE MEDICAL CARE</h3>
                                <p style={{color:"#0a4546"}} className="abouttext card-text">At ELITE MEDICAL CARE, Krishnagar, we believe that good health is the foundation of a better life. That’s why we have built a trusted space where expert doctors, advanced diagnostic facilities, and compassionate care come together under one roof.</p>
                                <p style={{color:"#0a4546"}} className='abouttext'>From specialist consultations to lab tests, X-ray, ECG, and other diagnostic services, we ensure every patient receives accurate, timely, and personalized healthcare. Our team of experienced doctors and skilled medical staff are committed to providing the highest standards of treatment with integrity and care.</p>
                                <p>Whether it’s routine check-ups, emergency care, or advanced diagnostics, ELITE MEDICAL CARE is your one-stop destination for complete healthcare support.</p>
                                <p>Our mission is simple: to make world-class medical care accessible, reliable, and affordable for every family in Krishnagar and beyond.</p>
                              
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <img src={elitemedicalcare} className="card-img-top" alt="elitemedicalcare"/>

                        </div>
                    </div>
                </div>

            </div>
            <br />
            <br />
</div>
        </div>
    )
}

export default About